// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"a9b0a852","710":"fe238df6","845":"19dc273d"}[chunkId] + ".chunk.js";
};